import { LocationQuery } from 'vue-router';
import { http } from '../../helpers/http.helper';
import { ApiResource } from '../../models/api-resource.interface';
import { Setting } from './settings.interface';

export class SettingsService {
   async getSettings(query?: LocationQuery) {
      const response = await http.get<ApiResource<Array<Setting>>>(`/settings`, { params: { ...query } });
      return response.data;
   }

   async getSetting(id: number, query?: LocationQuery) {
      const response = await http.get<Setting>(`/settings/${id}`, { params: { ...query } });
      return response.data;
   }

   async createSetting(setting: Partial<Setting>) {
      const response = await http.post<Setting>(`/settings`, setting);
      return response.data;
   }

   async updateSetting(id: number, setting: Partial<Setting>) {
      const response = await http.put<Setting>(`/settings/${id}`, setting);
      return response.data;
   }

   async getSettingNxtJob(query?: LocationQuery) {
      const response = await http.get<any>(`/setting/nxtjob`, { params: { ...query } });
      return response.data;
   }
}
